// extracted by mini-css-extract-plugin
export default {"countdownWrapper":"email-setting_countdownWrapper__5QaVS","inputSubtitle":"email-setting_inputSubtitle__OT3nK"};